// extracted by mini-css-extract-plugin
module.exports = {"label":"_2nDhnS","prize":"_3U9-m3","symbol":"_2Awv5d"};